module.exports = __webpack_public_path__ + "assets/SquareByAdjMidpoints.6872ed88855bf21062bbf7938a044b86.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/SquareByAdjMidpoints.gmt
// module id = 998
// module chunks = 0